import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.can_retry_abandoned`. */
export const editCanRetryAbandoned = async (can_retry_abandoned: object): Promise<any> =>
  writeSettingsFields({ can_retry_abandoned });
